import { jsx as _jsx } from "react/jsx-runtime";
export function Card({ elevated = false, style, children, ...rest }) {
    return (_jsx("article", { ...rest, style: {
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: 16,
            padding: 24,
            boxShadow: elevated ? "var(--shadow-md)" : undefined,
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            ...style,
        }, children: children }));
}
//# sourceMappingURL=Card.js.map